var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vant-image',{attrs:{"width":"100%","height":"100%","src":"https://gd-pub.jinshujufiles.com/hi/20200320125134_072018"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }